// extracted by mini-css-extract-plugin
module.exports = {"addInstrumentButton":"styles_addInstrumentButton__2DYrm"};